import { render, staticRenderFns } from "./AnswersReportExampleDetailBottom.vue?vue&type=template&id=74593b3a&"
import script from "./AnswersReportExampleDetailBottom.vue?vue&type=script&lang=js&"
export * from "./AnswersReportExampleDetailBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports